// const ruta = {
//     carros: 'http://localhost:5000/carros',
//     nuevoCarro: 'http://localhost:5000/guardar',
//     borrarCarro: "http://localhost:5000/delete/",
//     editarCarro: "http://localhost:5000/edit/",
//     comprobar: "http://localhost:5000/ifRender/"
// }

// IP Externa
const ruta = {
    carros: 'https://cargonz-api.herokuapp.com/carros',
    nuevoCarro: 'https://cargonz-api.herokuapp.com/guardar',
    borrarCarro: "https://cargonz-api.herokuapp.com/delete/",
    editarCarro: "https://cargonz-api.herokuapp.com/edit/",
    comprobar: "https://cargonz-api.herokuapp.com/ifRender/"
}

export default ruta